"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselPageCount: function() {
        return _index.TeachingPopoverCarouselPageCount;
    },
    renderTeachingPopoverCarouselPageCount_unstable: function() {
        return _index.renderTeachingPopoverCarouselPageCount_unstable;
    },
    teachingPopoverCarouselPageCountClassNames: function() {
        return _index.teachingPopoverCarouselPageCountClassNames;
    },
    useTeachingPopoverCarouselPageCountStyles_unstable: function() {
        return _index.useTeachingPopoverCarouselPageCountStyles_unstable;
    },
    useTeachingPopoverCarouselPageCount_unstable: function() {
        return _index.useTeachingPopoverCarouselPageCount_unstable;
    }
});
const _index = require("./components/TeachingPopoverCarouselPageCount/index");
